import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";

@Injectable({ providedIn: 'root' })
export class ListNavigationService {

    listUrl: string;
    listApiUrl: string;

    items?: any[];
    totalItems: number;

    fromPage: number;
    toPage: number;

    constructor(
        private router: Router,
        private http: HttpClient,
    ) {}

    saveListApiUrl(listApiUrl: string) {
        this.items = undefined;
        this.totalItems = 0;

        this.listApiUrl = listApiUrl;

        setTimeout(() => {
            this.listUrl = this.router.url;
        }, 100);

        this.fromPage = this.getPageFromUrl(this.listApiUrl);
        this.toPage = this.fromPage;
    }

    getListUrl() {
        if (
            this.listUrl &&
            this.router.url.startsWith(this.listUrl.split('?')[0])
        ) {
            return this.listUrl;
        } else {
            return this.router.url.split(/\/\d+/)[0];
        }
    }

    getPageFromUrl(listApiUrl: string) {
        return parseInt(listApiUrl.match(/(\?|&)page=(\d+)/)?.[2] || '1');
    }

    async getListItems(currentItem: any): Promise<any[]> {
        if (
            this.listApiUrl &&
            this.router.url.match(new RegExp('^' + this.listUrl.split('?')[0] + '/\\d+'))
        ) {
            if (!this.items) {
                await this.loadListPage();
            }

            let pageToPreload = this.getPageToPreload(currentItem);

            if (pageToPreload) {
                await this.loadListPage(pageToPreload);
            }

            return this.items || [];
        } else {
            return [];
        }
    }

    loadListPage(page?: number) {
        let listApiUrl = this.listApiUrl;

        if (page) {
            if (listApiUrl.match(/(\?|&)page=\d+/)) {
                listApiUrl = listApiUrl.replace(/(\?|&)page=\d+/, '$1page=' + page);
            } else {
                listApiUrl += (listApiUrl.includes('?') ? '&' : '?') + 'page=' + page;
            }
        }

        const thisComponent = this;

        return new Promise((resolve) => {
            this.http.get('/api' + listApiUrl).subscribe({
                next(response: any) {
                    let items = response.items || response.data.items || [];
                    thisComponent.totalItems = response.totalItems || response.data.totalItems || 0;

                    let page = thisComponent.getPageFromUrl(listApiUrl);

                    if (thisComponent.fromPage > page) {
                        thisComponent.fromPage = page;
                        thisComponent.items = [...items, ...(thisComponent.items || [])];
                    } else if (thisComponent.toPage < page) {
                        thisComponent.toPage = page;
                        thisComponent.items = [...(thisComponent.items || []), ...items];
                    } else {
                        thisComponent.items = items;
                    }

                    resolve(thisComponent.items);
                },
                error(err) {
                    thisComponent.items = [];
                    resolve(thisComponent.items);
                },
            })
        });
    }

    getPageToPreload(currentItem: any) {
        let currentItemIndex = null;

        // @ts-ignore
        let list: any[] = this.items;

        for (let i = 0; i < list.length; i++) {
            if (list[i].id == currentItem.id) {
                currentItemIndex = i;
            }
        }

        // if element first, then load previous page
        if (currentItemIndex === 0 && this.fromPage > 1) {
            return this.fromPage - 1;
        }

        // if element last, then load next page
        if (currentItemIndex === (list?.length - 1) && list.length < this.totalItems) {
            return this.toPage + 1;
        }
    }

}
